module.exports = __webpack_public_path__ + "img/cinamas.68b10f1e.jpg";